export default "__VITE_ASSET__DJogJEHQ__"